module.exports = __webpack_public_path__ + "img/0603-c.78927fcc.svg";